import React, { FC } from "react";
import { useSelector } from "react-redux";

import { ListControl, Till, Label } from "../../components/common";
import ProfileLayout from "../../layouts/Profile.layout";
import { selectCurrentUser } from "../../store/reducers/user";
import { settingsList } from "../../utils/prepareData/settings";

export const SettingsContacts: FC = () => {
  const { email, phone } = useSelector(selectCurrentUser);
  const data = settingsList({ email, phone });

  return (
    <ProfileLayout>
      <h1 className="hidden md:block theme-heading text-center mb-8">
        Email and phone
      </h1>

      <div className="hidden md:block theme-subheading text-center mb-16">
        We use your mobile number only for important updates on your invoices
      </div>

      <div className="w-full flex flex-col items-stretch">
        {data.map((contact) => (
          <ListControl key={contact.label}>
            <div className="border-t border-gray-50 py-6 w-full flex flex-row gap-x-6">
              <Till icon={contact.icon} />

              {contact.value ? (
                <Label label={contact.label}>{contact.value}</Label>
              ) : (
                <div className="items-center flex text-base">
                  {contact.label}
                </div>
              )}

              {contact.action}
            </div>
          </ListControl>
        ))}
      </div>
    </ProfileLayout>
  );
};
